export default __webpack_public_path__ + "static/media/notification.597a1820.svg";